import { hasConnectNow } from '../../Components/Organization/organizationUtils';
import { useCurrentProvider } from '../../Components/Permissions';
import { Permission } from '../../graphQL';

export const useShowConnectNowCallReports = () => {
  const { currentProvider, hasPermission } = useCurrentProvider();
  return (
    hasPermission(Permission.CrisisReportsViewAny) ||
    (hasPermission(Permission.CrisisReportsViewOwnorg) &&
      hasConnectNow(currentProvider.organizations[0]))
  );
};
